import ChatBubbleOutlineIcon from '@mui/icons-material/ChatBubbleOutline';
import React from 'react'
import Card from 'react-bootstrap/Card';
import { useState, useEffect, useContext } from 'react';
import HomeIcon from '@mui/icons-material/Home';
import EditIcon from '@mui/icons-material/Edit';
import FlightTakeoffIcon from '@mui/icons-material/FlightTakeoff';
import Person4Icon from '@mui/icons-material/Person4';
import { Link } from 'react-router-dom'
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import { useNavigate, useLocation } from 'react-router-dom';
import JapaneseHSchoolDay1 from './JapaneseHSchoolDay1';
import axios from 'axios';
import { ProductContext } from "../context/AppContext";
import Footer from './Common_Components/Footer';
const JapanHSchool = () => {
  const [activePage, setActivePage] = useState("Learning");
  const [days, setDays] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [isLoadingImage, setIsLoadingImage] = useState(true);
  const location = useLocation();
  const navigate = useNavigate();
  const LifeJapan = location.state;
  const categoryId = LifeJapan?.categoryId;
  const skitName = LifeJapan?.skitName;
  const { Translate } = useContext(ProductContext);
  const authToken = localStorage.getItem("AuthToken");

  useEffect(() => {
    const fetchDays = async () => {
      try {
        const response = await axios.get(
          `https://api.japaking.online/api/skit-day?categoryId=${categoryId}`,
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${authToken}`,
            },
          }
        );

        if (response.data.success) {
          setDays(response.data.message.days);
        }
      } catch (e) {
        console.log('Error getting the quiz type ', e);
      } finally {
        setIsLoading(false);
      }
    };
    fetchDays();
  }, [categoryId]);
  if (isLoadingImage) {

  }
  // If no data is available, redirect to "ComingSoon"
  useEffect(() => {
    if (!isLoading && days.length === 0) {
      navigate('/coming-soon', {
        state: {
          skitname: skitName,
        },
      });
    }
  }, [days, isLoading, navigate]);
  const [selectedLanguage, setSelectedLanguage] = useState('');
  const SelectLanguageLocal = localStorage.getItem("selectedLanguage");


  return (
    <div className='LifeInJapan d-flex flex-column' style={{ minHeight: "100vh" }}>
      <div className='container'>
        <div className='row'>
          <div className='col-md-12'>
            <div className='header_inner'>
              <div className='container'>
                <div className='row'>
                  <div className='col-md-12'>
                    <ArrowBackIosIcon onClick={() => navigate(-1)} className='icon_1' />
                    <h2>{skitName}</h2>
                    <ChatBubbleOutlineIcon onClick={() => navigate('/chat-with-staff')} className="logo_1" style={{ cursor: 'pointer', color: '#ffc0cb' }} />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="JapanHSchool" style={{ marginTop: "100px", marginBottom: "100px" }}>
        <div className="container">

          <div className="row">
            {days.map((day, index) => {
              return (
                <React.Fragment key={index}>
                  <div className="col-6 col-md-4 mb-3 d-flex justify-content-center">
                    <div
                      onClick={() =>
                        navigate('/JapaneseHSchoolDay1', {
                          state: {
                            dayId: day.day_id,
                            categoryId: categoryId,
                            dayName: day.day_name,
                            skitname: skitName,
                            dayLen: days.length,
                            imageURL: day.url,
                          },
                        })
                      }
                      style={{
                        textDecoration: 'none',
                        color: 'inherit',
                        cursor: 'pointer',
                        width: '100%',
                      }}
                    >
                      <Card className="lifeInJapanH_School_card h-100">
                        <Card.Img
                          variant="top"
                          src={isLoadingImage ? `${process.env.PUBLIC_URL}/assets/images/loading.png` : day.url}
                          onLoad={() => setIsLoadingImage(false)}
                          onError={() => setIsLoadingImage(false)}
                          style={{ objectFit: 'cover', height: '300px' }}
                        />
                        <Card.Body>
                          <Card.Title>{day.day_name}</Card.Title>
                        </Card.Body>
                      </Card>
                    </div>
                  </div>

                </React.Fragment>
              );

            })}
          </div>

        </div>
      </div>
      <Footer />
    </div>
  );
}

export default JapanHSchool;
